import { Grid } from '@material-ui/core'
import Modal from '../Modal'
import { StyledCancel } from './styles'
import { colors } from 'shared/styles/colors'
import Button from '../Button'
import { MdCancel, MdCheck } from 'react-icons/md'
import React from 'react'

interface IModalAnttRecusadaProps {
  openModal: boolean
  setOpenModal: (value: boolean) => void
  onConfirm: () => void
  onCancel?: () => void
  params?: { message: string; bloquearAnttNaoValida: boolean }
}

const ModalAnttRecusada: React.FC<IModalAnttRecusadaProps> = ({
  setOpenModal,
  openModal,
  onConfirm,
  onCancel,
  params,
}) => {
  return (
    <Modal
      openModal={openModal}
      showCloseButton={true}
      size="medium"
      onCloseModal={() => {
        setOpenModal(false)
      }}
    >
      <Grid container spacing={3}>
        <Grid item md={12}>
          <Grid container justifyContent={'center'}>
            <StyledCancel />
          </Grid>
        </Grid>
        <Grid item md={12} style={{ fontWeight: 700, color: colors.blue }}>
          <Grid container justifyContent={'center'}>
            A ANTT informada não está apta para transporte.
          </Grid>
        </Grid>

        <Grid item md={12} style={{ fontWeight: 700, color: colors.blue }}>
          <Grid container justifyContent={'center'}>
            {params?.message}
          </Grid>
        </Grid>

        {!params?.bloquearAnttNaoValida && (
          <Grid item md={12}>
            <Grid container justifyContent={'center'}>
              Deseja continuar?
            </Grid>
          </Grid>
        )}

        <Grid item xs={12} md={12}>
          <Grid container justifyContent={'center'}>
            <Grid item xs={6} md={6}>
              <Grid container justifyContent={'center'}>
                <Button
                  onClick={() => {
                    onCancel && onCancel()
                    setOpenModal(false)
                  }}
                  color={colors.red}
                  style={{ width: 150 }}
                >
                  <MdCancel />{' '}
                  {!params?.bloquearAnttNaoValida ? 'Cancelar' : 'Ok'}
                </Button>
              </Grid>
            </Grid>
            {!params?.bloquearAnttNaoValida && (
              <Grid item xs={6} md={6}>
                <Grid container justifyContent={'center'}>
                  <Button
                    onClick={() => {
                      onConfirm()
                      setOpenModal(false)
                    }}
                    color={colors.orange}
                    style={{ width: 150 }}
                  >
                    <MdCheck />
                    Concluir
                  </Button>
                </Grid>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  )
}

export default ModalAnttRecusada
